export default {
    mask: '+7 (000) 000 00 00',
}
